import { HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IdzUnauthorizedInterceptor } from 'src/app/zzz/securite/idz-unauthorized.interceptor';

@Injectable({
  providedIn: 'root',
})
export class SigtHttpClientFactory {
  constructor(private backend: HttpBackend, private interceptor: IdzUnauthorizedInterceptor) {}

  create(): HttpClient {
    return this.#createHttpClientWithInterceptor(this.backend, this.interceptor);
  }

  #createHttpClientWithInterceptor(
    backend: HttpBackend,
    interceptor: HttpInterceptor
  ): HttpClient {
    class CustomHttpHandler implements HttpHandler {
      constructor(private next: HttpHandler, private interceptor: HttpInterceptor) {}

      handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
        return this.interceptor.intercept(req, this.next);
      }
    }

    const customHandler = new CustomHttpHandler(backend, interceptor);
    return new HttpClient(customHandler);
  }
}
